import {
  MOTIVOCANCELACION_ERROR,
  MOTIVOCANCELACION_LOADING,
  MOTIVOCANCELACION_SUCCESS,
  MOTIVOCANCELACIONLABORATORIO_SUCCESS,
  MOTIVOCANCELACION_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import motivoCancelacionInitialState from "../initialStates/motivoCancelacionInitialState";

const motivoCancelacion = (state, { payload, type }) => {
  switch (type) {
    case MOTIVOCANCELACION_LOADING:
      return {
        ...state,
        motivoCancelacion: {
          ...state.motivoCancelacion,
          error: false,
          loading: true,
        },
      };
    case MOTIVOCANCELACION_SUCCESS:
      return {
        ...state,
        motivoCancelacion: {
          ...state.motivoCancelacion,
          loading: false,
          error: false,
          turnos: payload,
        },
      };
    case MOTIVOCANCELACIONLABORATORIO_SUCCESS:
      return {
        ...state,
        motivoCancelacion: {
          ...state.motivoCancelacion,
          loading: false,
          error: false,
          laboratorio: payload,
        },
      };
    case MOTIVOCANCELACION_ERROR:
      return {
        ...state,
        motivoCancelacion: {
          ...state.motivoCancelacion,
          error: payload,
          loading: false,
        },
      };
    case MOTIVOCANCELACION_RESET:
      return motivoCancelacionInitialState;
    case RESET_PORTAL_CONTEXT:
      return motivoCancelacionInitialState;

    default:
      return state;
  }
};

export default motivoCancelacion;
